import React from 'react';
import { TextField, MenuItem, Select } from "@mui/material";
import Grid from '@mui/material/Grid2';
import axios from 'axios';
import config from '../../config';
import { ConcepteIcon } from '../common/IconMap';
import { useAppContext } from '../AppContext';
import SelectConcepteTree from './SelectConcepteTree';

const fetchListConceptes = (jwtToken, userapp, onSuccess, onError) => {
  axios.get(`${config.apiBaseUrl}/v1/conceptes/byuserapp?userapp=${userapp}`, {
    headers: { Authorization: `${jwtToken}` }
  }).then((response) => {
    const list = response.data.sort((a, b) => a.nom.localeCompare(b.nom));
    onSuccess(list);
  }).catch((err) => {
    onError(err);
  });
};

const SelectConcepteTextField = ({
  label,
  value,
  onChange,
  listConceptes,
  onlyLeaves = false,
  forceClassic = false,
  size = 'small',
  popperWidth
}) => {
  const { conceptesTree, entitatsTransversals, graphMode } = useAppContext();

  // Si tenim arbre de conceptes i no estem forçant el mode clàssic ni el backend és només CLASSIC:
  const shouldUseGraph = !forceClassic && graphMode !== 'CLASSIC' && conceptesTree && conceptesTree.length > 0;

  if (shouldUseGraph) {
    return (
      <SelectConcepteTree
        label={label}
        value={value}
        onChange={onChange}
        tree={conceptesTree}
        entitats={entitatsTransversals}
        onlyLeaves={onlyLeaves}
        size={size}
        popperWidth={popperWidth}
      />
    );
  }

  // Fallback tradicional
  const sortedList = listConceptes
    ? [...listConceptes].sort((a, b) => a.nom.localeCompare(b.nom))
    : [];

  return (
    <TextField
      fullWidth
      size={size}
      label={label}
      select
      value={value || ''}
      onChange={onChange}
    >
      {sortedList.map((c, idx) => (
        <MenuItem key={c.id ? `conc-${c.id}` : `${c.nom}-${idx}`} value={c.nom}>
          <Grid sx={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
            <ConcepteIcon concept={c.nom} />
          </Grid>                      
        </MenuItem>        
      ))}
    </TextField>
  );  
};

const SelectConcepte = ({
  label,
  value,
  onChange,
  listConceptes,
  forceClassic = false,
  size = 'small',
  fullWidth = false,
  sx = {}
}) => {
  const { conceptesTree, entitatsTransversals, graphMode } = useAppContext();

  const shouldUseGraph = !forceClassic && graphMode !== 'CLASSIC' && conceptesTree && conceptesTree.length > 0;

  if (shouldUseGraph) {
    return (
      <SelectConcepteTree
        label={label}
        value={value}
        onChange={onChange}
        tree={conceptesTree}
        entitats={entitatsTransversals}
        allowRootSelection={true}
        onlyLeaves={false}
        size={size}
        fullWidth={fullWidth}
        sx={{
          minWidth: 180,
          width: { xs: '100%', sm: 240 },
          maxWidth: 280,
          ...sx
        }}
      />
    );
  }

  const sortedList = listConceptes
    ? [...listConceptes].sort((a, b) => a.nom.localeCompare(b.nom))
    : [];

  return (
    <Select
      value={value || ''}
      size={size}
      label={label}
      onChange={onChange}
      sx={{ minWidth: 150, maxWidth: 280, ...sx }}
    >
      {sortedList.map((c, idx) => (
        <MenuItem key={c.id ? `conc-${c.id}` : `${c.nom}-${idx}`} value={c.nom}>
          <Grid sx={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
            <ConcepteIcon concept={c.nom} />
          </Grid>                      
        </MenuItem>        
      ))}
    </Select>
   
  );
};

export { SelectConcepteTextField, SelectConcepte, SelectConcepteTree, fetchListConceptes };